const Template = (($) => {
    const NAME = 'template';
    const DATA_KEY = `bs.${NAME}`;
    const JQUERY_NO_CONFLICT = $.fn[NAME];


    const Default = {
        templateTarget: '', // jquery selector to append template mark up
        templatePrefix: '', // collection prefix name
        templateRow: 'tr',  // jquery selector that indicate the row containing the template
        templateAdd: '',    // jquery selector that trigger adding of a template
        templateRemove: '', // jquery selector that trigger removing of a template
        templateRemoveFirst: true   // allow the removal of the first template
    };

    class Template {
        constructor(element, config) {
            this._config = config;
            this._element = element;

            const self = this;

            // register for click event on add and remove
            $(document).off('click', this._config.templateAdd).on('click', this._config.templateAdd, (e) => {
                e.preventDefault();
                this._add();
            }).off('click', this._config.templateRemove).on('click', this._config.templateRemove, function (e) {
                e.preventDefault();
                self._remove($(this));
            });

        }

        _add() {
            $(this._config.templateTarget).append($(this._element).html());
            this._rebuildName();
        }

        _remove($remove) {
            $remove.closest(this._config.templateRow).remove();

            // prevent user from removing the first row
            if (!this._config.templateRemoveFirst) {
                $(this._config.templateTarget + ' ' + this._config.templateRow).eq(0).find(this._config.templateRemove).remove();
            }

            this._rebuildName();
        }

        _rebuildName() {
            const
                self = this,
                $target = $(this._config.templateTarget),
                $form = $target.closest('form').removeData('unobtrusiveValidation validator');

            // re-build the template id and name via indexing
            $target.find(this._config.templateRow).each(function (index) {
                const $row = $(this);
                $row.find('select[data-template-name]').each(function () {
                    const $select = $(this),
                        id = `${self._config.templatePrefix}_${index}__${$select.data('template-name')}`;
                    $select.attr('id', id).attr('aria-describedby', id).attr('name', `${self._config.templatePrefix}[${index}].${$select.data('template-name')}`).select();
                });

                $row.find('input[data-template-name]').each(function () {
                    const $input = $(this),
                        id = `${self._config.templatePrefix}_${index}__${$input.data('template-name')}`;
                    $input.attr('id', id).attr('aria-describedby', id).attr('name', `${self._config.templatePrefix}[${index}].${$input.data('template-name')}`);

                    //for dependent properties
                    var dependentProperty = $input.data('template-dependentpropertyname');
                    if (dependentProperty) {
                        $.each($input[0].attributes, function (i, attr) {
                            if (attr.name.match(/^.*dependentproperty$/)) {
                                $input.attr(attr.name, `${self._config.templatePrefix}[${index}].${dependentProperty}`);
                            }
                        });
                    }

                    if ($input.hasClass('js-mask')) {
                        $input.mask();
                    }
                    if ($input.hasClass('js-date')) {
                        $input.date();
                    } else if ($input.hasClass('js-numeric')) {
                        $input.numeric();
                    } else if ($input.hasClass('js-token')) {
                        $input.token();
                    } else if ($input.hasClass('js-upload')) {
                        $input.upload();
                    } else {
                        if ($input.hasClass('js-checkbox')) {
                            $input.checkbox();
                        } else if ($input.hasClass('js-switch')) {
                            $input.switch();
                        } else if ($input.hasClass('js-switchery')) {
                            $input.switchery();
                        } else if ($input.hasClass('js-radio')) {
                            $input.radio();
                        }
                    }
                });

                $row.find('textarea[data-template-name]').each(function () {
                    const $textarea = $(this),
                        id = `${self._config.templatePrefix}_${index}__${$textarea.data('template-name')}`;
                    $textarea.attr('id', id).attr('aria-describedby', id).attr('name', `${self._config.templatePrefix}[${index}].${$textarea.data('template-name')}`);

                    if ($textarea.hasClass('js-editor')) {
                        $textarea.editor();
                    }
                });

                $row.find('span[data-template-name]').each(function () {
                    const $span = $(this);
                    $span.attr('data-valmsg-for', `${self._config.templatePrefix}[${index}].${$span.data('template-name')}`);
                });
            });

            // re-build validators
            $.validator.unobtrusive.parse($form[0]);
        }

        dispose() {
            $.removeData(this._element, DATA_KEY);
            this._config = null;
            this._element = null;
        }

        static _jQueryInterface() {
            return this.each(function () {
                const $this = $(this);
                let data = $this.data(DATA_KEY);
                const config = $.extend({}, Default, $this.data());
                if (!data) {
                    data = new Template(this, config);
                    $this.data(DATA_KEY, data);
                }
            });
        }
    }

    $(() => Template._jQueryInterface.call($('script[data-template-target]')));
    $(document).ajaxStop(() => Template._jQueryInterface.call($('script[data-template-target]')));

    $.fn[NAME] = Template._jQueryInterface;
    $.fn[NAME].Constructor = Template;
    $.fn[NAME].noConflict = function () {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return Template._jQueryInterface;
    }

    return Template;
})(jQuery);